import {
    getAddedMonthsLocalizedDate,
    getEarliestDayTime,
    getTomorrowLocalizedDate,
    getLatestDayTime,
} from '@mews-commander/utils';
import { DateTimeLocalizationInfo } from '@mews/framework';

interface MailQueueItemQueryParams {
    enterpriseId: string;
    email: string | null | undefined;
    nowUtc: string;
    timezone: string;
    localizationInfo: DateTimeLocalizationInfo;
}

export const getMailQueueItemQuery = ({
    enterpriseId,
    email,
    nowUtc,
    timezone,
    localizationInfo,
}: MailQueueItemQueryParams) => ({
    Custom: true,
    EnterpriseId: enterpriseId,
    Email: email,
    'States.Scheduled': true,
    'States.Success': true,
    'States.Failed': true,
    'States.Waiting': true,
    'States.Processing': true,
    'States.Canceled': true,
    'States.Warning': true,
    'States.TimedOut': true,
    Filter: 'Created',
    'Start.Date': getAddedMonthsLocalizedDate({ utc: nowUtc, timezone, monthCount: -3 }),
    'Start.Time': getEarliestDayTime(localizationInfo),
    'End.Date': getTomorrowLocalizedDate(nowUtc, timezone),
    'End.Time': getLatestDayTime(localizationInfo),
});
